/**
 * .tuMetrics {"tu1": 0.95, "tu2": 0.97, "tu3": 1, "notes": "Access seat vs activity duties", "tuVersion": "2.5"}
 * .help "Who can admin or own, and which assigned activity a person can perform."
 */
import type { AccessRole, ActivityRole } from '../../types/index.ts';

export const ACTIVITY_ROLE_LABEL: Record<ActivityRole, string> = {
  announcements: 'Announcements',
  reports: 'Reports',
  project_accounting: 'Accounting',
};

export function isOwnerRole(role: AccessRole | undefined | null): boolean {
  return role === 'owner';
}

export function isAdminRole(role: AccessRole | undefined | null): boolean {
  return role === 'owner' || role === 'administrator';
}

export function isManagerRole(role: AccessRole | undefined | null): boolean {
  return role === 'manager';
}

export function hasActivityRole(
  user: { activityRoles?: ActivityRole[] | null } | null | undefined,
  role: ActivityRole,
): boolean {
  return !!user?.activityRoles?.includes(role);
}

export function hasReportsAccess(
  user: { activityRoles?: ActivityRole[] | null } | null | undefined,
): boolean {
  return hasActivityRole(user, 'reports');
}
